import { FC } from 'react';
import { Box } from '@material-ui/core';
import { ProductEnhancerProps } from './types';
import { useProductEnhancer } from './hooks/useProductEnhancer';
import {
  EnhancerHeader,
  EnhancedFieldCard,
  OriginalFieldCard,
  EnhancedCardLoading
} from './components';
import { FieldsGrid, ProductEnhancerContainer, FieldCell } from './styled';

export const MobileProductEnhancer: FC<ProductEnhancerProps> = () => {
  const {
    originalFields,
    enhancedFields,
    enhanceLoadingElement,
    enhancedCsvData,
    onEnhanceClick,
    onReEnhanceClick,
    onExportClick,
    onTagRemoveClick,
    onTextAreaChange,
    onEnhanceAllAlick,
    onLabelValueChange
  } = useProductEnhancer();

  const enhanceAllLoading = enhanceLoadingElement === 'all';

  return (
    <ProductEnhancerContainer>
      <EnhancerHeader
        enhancedCsvData={enhancedCsvData}
        enhanceAllLoading={!!enhanceLoadingElement}
        onExportClick={onExportClick}
        onEnhanceAllClick={onEnhanceAllAlick}
      />

      {/* FIELDS MAP */}
      <FieldsGrid>
        {originalFields.map(original => (
          <Box key={original.id}>
            <FieldCell gridColumn="1" style={{ marginBottom: 12 }}>
              {/* LEFT SIDE */}
              <OriginalFieldCard field={original} />
            </FieldCell>

            {/* RIGHT SIDE (do not show when Enhance All is working) */}
            {!enhanceAllLoading && (
              <FieldCell gridColumn="2">
                <EnhancedFieldCard
                  isLoading={enhanceLoadingElement === original.id}
                  field={enhancedFields[original.id]}
                  onEnhanceClick={onEnhanceClick}
                  onReEnhanceClick={onReEnhanceClick}
                  onTagRemoveClick={onTagRemoveClick}
                  onTextAreaChange={onTextAreaChange}
                  onLabelValueChange={onLabelValueChange}
                />
              </FieldCell>
            )}
          </Box>
        ))}

        {/* Big right side loader for Enhance All */}
        {enhanceAllLoading && (
          <FieldCell gridColumn="2" spanRows={originalFields.length}>
            <EnhancedCardLoading />
          </FieldCell>
        )}
      </FieldsGrid>
    </ProductEnhancerContainer>
  );
};
